import React, { useEffect, useState } from 'react';
import { Users, UserCheck, Award, Shield } from 'lucide-react';
import { TypeAnimation } from 'react-type-animation'; // Efekt için kütüphaneyi ekledik

const Hero = () => {
  const [stats, setStats] = useState({
    onlineMembers: 0,
    totalMembers: 0,
    totalCustomers: 0,
    staff: 10
  });

  useEffect(() => {
    const allUsers = JSON.parse(localStorage.getItem('mockUsers') || '[]');
    const allOrders = JSON.parse(localStorage.getItem('orders') || '[]');
    const loginSessions = JSON.parse(localStorage.getItem('loginSessions') || '[]');
    
    const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
    const onlineCount = loginSessions.filter(session => session > fiveMinutesAgo).length;
    
    setStats({
      onlineMembers: onlineCount || 979,
      totalMembers: allUsers.length || 4108,
      totalCustomers: allOrders.length || 560,
      staff: 10
    });
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-black via-gray-900 to-black overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-900/20 via-transparent to-transparent"></div>
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-green-500 rounded-full filter blur-[128px] animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-600 rounded-full filter blur-[128px] animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="mb-8 inline-block">
          <img src="/logo.webp" alt="Swenzy" className="w-24 h-24 rounded-2xl shadow-2xl shadow-green-500/50 transform hover:scale-110 transition-transform duration-300" />
        </div>
        
        {/* YAZILMA EFEKTİ BURADA */}
        <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-green-400 via-green-300 to-green-500 text-transparent bg-clip-text">
          <TypeAnimation
            sequence={[
              'Swenzy Bots', 
              3000,          
              'Profesyonel Botlar', 
              2000,          
              'Hızlı Çözümler', 
              2000,
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
          />
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto">
          Hızlı, güvenilir ve profesyonel Discord botlarının tek adresi.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-xl p-6 hover:border-green-500 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/20 group">
            <div className="flex justify-center mb-3">
              <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                <Users className="w-6 h-6 text-green-400" />
              </div>
            </div>
            <div className="text-3xl font-bold text-green-400 mb-1">{stats.onlineMembers}</div>
            <div className="text-sm text-gray-400">Çevrimiçi Üye</div>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-xl p-6 hover:border-green-500 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/20 group">
            <div className="flex justify-center mb-3">
              <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                <UserCheck className="w-6 h-6 text-green-400" />
              </div>
            </div>
            <div className="text-3xl font-bold text-green-400 mb-1">{stats.totalMembers}</div>
            <div className="text-sm text-gray-400">Toplam Üye</div>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-xl p-6 hover:border-green-500 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/20 group">
            <div className="flex justify-center mb-3">
              <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                <Award className="w-6 h-6 text-green-400" />
              </div>
            </div>
            <div className="text-3xl font-bold text-green-400 mb-1">{stats.totalCustomers}</div>
            <div className="text-sm text-gray-400">Toplam Müşteri</div>
          </div>

          <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-xl p-6 hover:border-green-500 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/20 group">
            <div className="flex justify-center mb-3">
              <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                <Shield className="w-6 h-6 text-green-400" />
              </div>
            </div>
            <div className="text-3xl font-bold text-green-400 mb-1">{stats.staff}</div>
            <div className="text-sm text-gray-400">Swenzy Personeli</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;